import { useMutation, useQueryClient } from "@tanstack/react-query";
import { acceptReferralsRules, payOutReferralsReward } from "./services";

export const useAcceptReferralRulesMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: acceptReferralsRules,
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ["referralsStatus"],
      }),
  });
};

export const usePayOutReferralsRewardMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: payOutReferralsReward,
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ["referralsStatus"],
      }),
  });
};
